import React from "react";
import { UseFormRegister, RegisterOptions } from "react-hook-form";
import uniqueId from "lodash.uniqueid";
import { cn } from "@/utils";

interface InputProps {
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  name: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any;
  labelClass?: string;
  id?: string;
  className?: string;
  validationOptions?: RegisterOptions;
}

const Input: React.FC<InputProps> = ({
  register,
  name,
  id,
  className,
  labelClass,
  type = "text",
  required = false,
  validationOptions,
  placeholder,
  errors
}) => {
  const _id = !id ? uniqueId() : id;
  return (
    <div className="relative">
      <input
        {...register(name, {
          required,
          ...(validationOptions ? validationOptions : {}) // Add extra validation options if provided
        })}
        id={name}
        type={type}
        placeholder={placeholder}
        className={cn(
          "block p-4 w-full bg-transparent focus:outline-none border peer placeholder:text-transparent",
          errors ? "error-text" : "text-dark border-dark",
          className
        )}
      />
      <label
        htmlFor={_id}
        className={cn(
          "absolute pointer-events-none will-change-transform transition-transform -translate-y-[4.25rem] left-4 peer-placeholder-shown:-translate-y-10 peer-focus:-translate-y-[4.25rem] inline-block bg-emerald-50 px-1",
          errors && "error-text",
          labelClass
        )}
      >
        {placeholder}
      </label>
      {errors && !!errors.message && <span className="error-text">{errors.message}</span>}
      {errors && errors.type === "required" && (
        <span className="error-text">This field is required</span>
      )}
    </div>
  );
};

export default Input;
